import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@icon/list-unordered-v2.svg'
import _imports_1 from '@icon/flag.svg'


const _hoisted_1 = { class: "label-pic is-blue" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ReferencedText = _resolveComponent("ReferencedText")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!
  const _directive_ticket = _resolveDirective("ticket")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    showSubTitle: false
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          width: "var(--icon-24)",
          height: "var(--icon-24)",
          color: "#1565C0"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" ToDo task added for you ")
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification.toDos, (todo, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "notification__todo"
          }, [
            (todo.structuredDescription?.html || todo.structuredDescription?.text)
              ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 0,
                  size: "medium",
                  color: "monochrome-06",
                  darkColor: "monochrome-03",
                  weight: "400",
                  className: "notification__todo-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ReferencedText, {
                      resetStyle: true,
                      html: _ctx.notification.getTodoName(todo)
                    }, null, 8, ["html"])
                  ]),
                  _: 2
                }, 1024))
              : (!todo.relatedUrl)
                ? _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                    key: 1,
                    size: "medium",
                    color: "monochrome-06",
                    darkColor: "monochrome-03",
                    weight: "400",
                    className: "notification__todo-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.notification.getTodoName(todo) || _ctx.$t("none")), 1)
                    ]),
                    _: 2
                  }, 1024)), [
                    [_directive_ticket, { wholeLink: true, todo: _ctx.notification.getProjectId(todo) }]
                  ])
                : (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: todo?.relatedUrl
                  }, _toDisplayString(_ctx.notification.getTodoName(todo) || _ctx.$t("none")), 9, _hoisted_2)),
            (todo.urgent)
              ? (_openBlock(), _createBlock(_component_icon, {
                  key: 3,
                  data: _imports_1,
                  fill: true,
                  width: "14",
                  height: "14",
                  class: "notification__todo-icon",
                  color: "#D32F2F"
                }))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["notification"]))
}